/**
 * Hjælp til visuelle artikelelementer (lister, tags, prisleje).
 */

/** Bullet-linjer som "Vægt: 360 g" eller "**Vægt:** 360 g" → tabelrækker */
export function parseBulletSpecs(bullets) {
  if (!bullets?.length) return []
  const rows = []
  for (const text of bullets) {
    const m =
      text.match(/^\*\*([^*]+)\*\*[:\s–-]+(.+)$/i) ||
      text.match(/^([^:]+)[:\s–-]+(.+)$/)
    if (m) {
      const label = m[1].trim()
      const value = m[2].trim()
      if (label.length > 1 && value.length > 0) {
        rows.push({ key: label.toLowerCase(), label, value })
      }
    }
  }
  return rows
}

export function extractBulletPoints(markdown) {
  if (!markdown?.trim()) return []
  return markdown
    .split('\n')
    .map((line) => line.match(/^\s*[-*]\s+(.+)$/))
    .filter(Boolean)
    .map((m) => m[1].trim().replace(/\*\*/g, ''))
}

export function splitProseAndBullets(content) {
  if (!content?.trim()) return { prose: '', bullets: [] }
  const bullets = extractBulletPoints(content)
  const prose = content
    .replace(/^\s*[-*]\s+.+$/gm, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
  return { prose, bullets }
}

const AUDIENCE_TAGS = [
  { id: 'beginner', label: 'Begynder', re: /\bbegynder\b/i },
  { id: 'intermediate', label: 'Øvet', re: /\b(øvet|mellemniveau|klubspiller)\b/i },
  { id: 'advanced', label: 'Avanceret', re: /\b(avanceret|erfaren|konkurrence|pro)\b/i },
  { id: 'control', label: 'Kontrol', re: /\bkontrol\b/i },
  { id: 'power', label: 'Power', re: /\bpower\b/i },
  { id: 'allround', label: 'Allround', re: /\ballround\b/i },
]

export function detectAudienceTags(content) {
  if (!content?.trim()) return []
  const seen = new Set()
  return AUDIENCE_TAGS.filter((t) => {
    if (!t.re.test(content) || seen.has(t.id)) return false
    seen.add(t.id)
    return true
  })
}

export function parsePrisleje(content) {
  const m = (content || '').match(/\*\*(Billigt|Gennemsnit|Dyrt)\*\*/i)
  if (!m) return { tier: null, reason: content || '' }
  const tier = m[1]
  const reason = content
    .replace(/\*\*[^*]+\*\*/g, '')
    .replace(/\s+/g, ' ')
    .trim()
  return { tier, reason }
}

export const SECTION_UI = {
  introduction: {
    step: 1,
    subtitle: 'Overblik over battet',
    accent: '#6366f1',
  },
  specs: {
    step: 2,
    subtitle: 'Konstruktion og teknologi',
    accent: '#0ea5e9',
  },
  audience: {
    step: 3,
    subtitle: 'Hvem battet passer til',
    accent: '#8b5cf6',
  },
  priceTier: {
    step: 4,
    subtitle: 'Prisniveau',
    accent: '#ec4899',
  },
}
